import {t} from "../../../../shared/services/i18n";

export const SESSION_PER_WEEK_LABELS = {
    1: 'oncePerWeek',
    2: 'twicePerWeek',
    3: 'threeTimesPerWeek',
    4: 'fourTimesPerWeek',
    5: 'fiveTimesPerWeek',
    6: 'sixTimesPerWeek',
    7: 'sevenTimesPerWeek'
}

export const FREQUENCY_COLUMN_LABEL_KEYS = {
    1: 'courseLimitations1xWeek',
    2: 'courseLimitations2xWeek',
    3: 'courseLimitations3xWeek',
    4: 'courseLimitations4xWeek',
    5: 'courseLimitations5xWeek',
    6: 'courseLimitations6xWeek',
    7: 'courseLimitations7xWeek',
};


export const SESSION_PER_WEEK_OPTIONS = [1, 2, 3, 4, 5, 6, 7]

export const getSessionPerWeekFilterOptions = () =>
    SESSION_PER_WEEK_OPTIONS.map(value => ({
        value,
        text: t(SESSION_PER_WEEK_LABELS[value])
    }))
